import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import InputField from "../inputComponents/InputField";
import SelectField from "../inputComponents/SelectField";
import Message from "../inputComponents/Message";
import Loading from "../../childComponents/appComponents/Loading";
import FileUpload from "../appComponents/FileUpload";

/* For Image Crop */
import Crop from "../appComponents/Crop";
import ServerImages from "../appComponents/ServerImages";
import CropRatio from "../appComponents/CropRatio";
/* End of For Image Crop */

const ModalPos = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

  const ADMINNAME = localStorage.getItem("auth_name");
  const today = new Date().toISOString().split("T")[0];
  const BUTTON_NAME = "POST CONTENT"; // Submit Button Name
  //Fetches all Form
  const [message, setMessage] = useState("");
  const [actionType, setActionType] = useState("");
  const [allformData, setAllFormData] = useState({
    input: {
      layout: null,
      status02: "publish",
      creationDate: today,
      searchTitle: null,
      captions: null,
      chosse009: "2",
      readShow01: null,
      addressLink: null,
      pageLink: null,
    },
    select: {
      pageLayout: "",
      category: "1",
      textDisplay: "auto",
      layoutDisplay: "1",
      width01: "auto",
      videod: "",
      getPageLink: "",
    },
  });

  const [reloadState, setReloadState] = useState({
    btnLoading: BUTTON_NAME,
    loading: true,
  });

  /* For Image Crop */
  const [returnRatio, setReturnRatio] = useState("");
  const [returnCrop, setReturnCrop] = useState("");
  const [cropImage, setCropImage] = useState("");
  const [image, setImage] = useState("");
  const [closeModal, setCloseModal] = useState(false);
  const [closeImageModal, setCloseImageModal] = useState(false);
  /* End of For Image Crop */
  const [returnUpload, setReturnUpload] = useState("");

  const [options, setOptions] = useState({
    pageLayout: [
      { values: "title_show_echo_01zz", item: "Latest Press" },
      { values: "title_show_echo_01", item: "Public Announcement" },
      { values: "title_show_echo_02", item: "Other News" },
      { values: "title_show_echo_03", item: "Speeches" },
      { values: "title_advert_02", item: "Poster" },
      { values: "title_advert_utube", item: "Youtube" },
      { values: "title_show_echo_01wa", item: "Download" },
      // { values: "title_show_echo_02zz", item: "2nd Other News" },
      // { values: "title_show_echo_03zz", item: "2nd Speeches" },
      // { values: "title_show_echo_04a", item: "1st News Flash" },
      // { values: "title_show_echo_04b", item: "2nd News Flash" },
      // { values: "title_show_echo_04c", item: "3rd News Flash" },
      // { values: "title_show_echo_01wa17", item: "Highways" },
      // { values: "title_show_echo_01wa18", item: "Services" },
      // { values: "title_show_echo_01wa19", item: "Ongoing" },
      // { values: "title_advert_01wa", item: "Flash Banner" },
      // { values: "title_advert_01wb", item: "2nd Flash Banner" },
      // { values: "title_advert_01", item: "1st Photo News" },
      // { values: "title_advert_03", item: "2nd Photo News" },
      // { values: "title_advert_04", item: "2nd Poster" },
    ],
    //Latest Press, Public Announcement, 1st Other News, 2nd Other News, 1st Speeches, 2nd Speeches, 1st News Flash, 2nd News Flash, 3rd News Flash, Highways, Services, Ongoing, 1st Flash Banner, 2nd Flash Banner, 1st Photo News, 2nd Photo News, 1st Poster, 2nd Poster, Youtube, Download
    textDisplay: [
      { values: "auto", item: "Default" },
      // { values: "all", item: "Display All" },
      { values: "0px", item: "0nly (Read More)" },
      // { values: "150px", item: "150 (Read More)" },
      // { values: "250px", item: "250 (Read More)" },
      // { values: "350px", item: "350 (Read More)" },
      // { values: "450px", item: "450 (Read More)" },
      // { values: "550px", item: "550 (Read More)" },
      // { values: "650px", item: "650 (Read More)" },
      // { values: "750px", item: "750 (Read More)" },
    ],

    layoutDisplay: [
      { values: "auto", item: "Default" },
      { values: "1", item: "Static Menu" },
      { values: "2", item: "Drop Menu" },
    ],

    width01: [
      { values: "auto", item: "Default" },
      { values: "10", item: "10%" },
      { values: "20", item: "20%" },
      { values: "30", item: "30%" },
      { values: "40", item: "40%" },
      { values: "50", item: "50%" },
      { values: "60", item: "60%" },
      { values: "70", item: "70%" },
      { values: "80", item: "80%" },
      { values: "90", item: "90%" },
      { values: "100", item: "100%" },
    ],

    videod: [
      //{ values: "youtube", item: "Default" },
      { values: "link", item: " Address Link" },
      { values: "google", item: "Google Hash Link" },
      { values: "youtube", item: "Youtube Hash Link" },
    ],

    category: [],

    getPageLink: [],
  });

  const layoutVisibility = {
    title_show_echo_01zz: {
      //Latest Press
      showGeneral: true,
      showImageSettings: true,
      showMessage: true,
      showTextDisplay: true,
      showSearchTitle: true,
      showLayout: true,
      showCropImage: true,
      showUploadImage: true,
      showLinks: false,
      showPoster: false,
      showLayoutDisplay: false,
    },

    title_show_echo_01: {
      //Public Announcement
      showGeneral: true,
      showImageSettings: true,
      showMessage: true,
      showTextDisplay: true,
      showSearchTitle: true,
      showLayout: true,
      showCropImage: true,
      showUploadImage: true,
      showLinks: false,
      showLayoutDisplay: true,
      showPoster: false,
    },

    title_show_echo_02: {
      //1st Other News
      showGeneral: true,
      showImageSettings: true,
      showMessage: true,
      showTextDisplay: true,
      showSearchTitle: true,
      showLayout: true,
      showCropImage: true,
      showUploadImage: true,
      showLinks: false,
      showLayoutDisplay: true,
      showPoster: false,
    },

    title_show_echo_03: {
      //1st Speeches
      showGeneral: true,
      showImageSettings: true,
      showMessage: true,
      showTextDisplay: true,
      showSearchTitle: true,
      showLayout: true,
      showCropImage: true,
      showUploadImage: true,
      showLinks: false,
      showLayoutDisplay: true,
      showPoster: false,
    },

    title_advert_02: {
      //1st Poster
      showGeneral: true,
      showImageSettings: true,
      showMessage: false,
      showTextDisplay: false,
      showSearchTitle: true,
      showLayout: true,
      showCropImage: true,
      showUploadImage: true,
      showLinks: true,
      showLayoutDisplay: false,
      showPoster: true,
    },

    title_advert_utube: {
      //Youtube
      showGeneral: true,
      showImageSettings: true,
      showMessage: false,
      showTextDisplay: false,
      showSearchTitle: true,
      showLayout: true,
      showCropImage: false,
      showUploadImage: false,
      showLinks: true,
      showLayoutDisplay: false,
      showPoster: false,
    },

    title_show_echo_01wa: {
      //Download
      showGeneral: true,
      showImageSettings: false,
      showMessage: false,
      showTextDisplay: false,
      showSearchTitle: true,
      showLayout: true,
      showCropImage: false,
      showUploadImage: true,
      showLinks: false,
      showLayoutDisplay: false,
      showPoster: false,
    },
  };

  const currentLayout = layoutVisibility[allformData.select.pageLayout] || {
    showGeneral: false,
    showImageSettings: false,
    showLayoutDisplay: false,
    showTextDisplay: false,
    showSearchTitle: false,
    showLayout: false,
    showCropImage: false,
    showUploadImage: false,
    showLinks: false,
    showPoster: false,
    showMessage: false,
  };

  function extractColumn(arr, column, value) {
    return arr.map((x) => ({
      values: x[value],
      item: x[column],
    }));
  }

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setAllFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  useEffect(() => {
    const selectedId = allformData.select.getPageLink;

    if (!selectedId) return;

    const selectedPage = options.getPageLink.find(
      (item) => item.values == selectedId,
    );

    if (selectedPage) {
      const pageName = selectedPage.item.toLowerCase().replace(/\s+/g, "-");

      const baseUrl = FRONTEND_URL.replace(/\/+$/, "");

      const generatedLink = `${baseUrl}/${pageName}/${selectedId}`;

      setAllFormData((prev) => ({
        ...prev,
        input: {
          ...prev.input,
          pageLink: generatedLink,
        },
      }));
    }
  }, [allformData.select.getPageLink, options.getPageLink, FRONTEND_URL]);

  //replaces each first character of a word with its uppercase version
  function ucwords(str = "") {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }
  useEffect(() => {
    if (!props.editposts) return;

    const isEdit = props.editposts.id;

    // ✅ EDIT MODE (load DB values)
    if (isEdit) {
      setImage(props.editposts.passport || "");
      setMessage(props.editposts.story01 || "");
      setReturnRatio(props.editposts.cropSize || "");
      setAllFormData((prev) => ({
        ...prev,
        input: {
          layout: props.editposts.title || "",
          searchTitle: props.editposts.storyTitle || "",
          status02: props.editposts.status02 || "",

          addressLink: props.editposts.addressLink?.split("*Locat*")?.[0]?.trim() || "",
          readShow01: props.editposts.readShow01 || "",
          chosse009: props.editposts.chosse009 || "",
          captions: props.editposts.captions || "",
          creationDate:
            props.editposts.daterqwTramp || today
              ? new Date(props.editposts.daterqwTramp * 1000)
                  .toISOString()
                  .split("T")[0]
              : "",
        },
        select: {
          pageLayout: props.editposts.columes || "",
          category: props.editposts.pageName || "",
          getPageLink: props.editposts.pageName || "",
          textDisplay: props.editposts.textSize || "",
          layoutDisplay: props.editposts.display01 || "",
          width01: props.editposts.width01 || "",
          videod:
            props.editposts.addressLink?.split("*Locat*")?.[1]?.trim() || "",
        },
      }));
    }
    // ✅ ADD MODE (use defaults)
    else {
      const today = new Date().toISOString().split("T")[0];

      setAllFormData({
        input: {
          layout: "",
          searchTitle: "",
          status02: "publish",
          addressLink: "",
          readShow01: "",
          chosse009: "2",
          captions: "",
          creationDate: today,
        },
        select: {
          pageLayout: "",
          category: "1",
          textDisplay: "auto",
          layoutDisplay: "1",
          width01: "auto",
          videod: "",
          getPageLink: "",
        },
      });

      setMessage("");
      setReturnRatio("");
    }

    setReloadState((prev) => ({
      ...prev,
      btnLoading: props.modalTitle,
      loading: false,
    }));

    (async () => await populateSelectMenu())();
  }, [props.editposts, props.modalTitle]);
  
  const populateSelectMenu = async () => {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([axios.get(`${BASE_URL}catdata`)]);

      const [categoryData] = responses;

      // populate the select menu
      const populateSelect = (colume, columeObject, columeName, value) => {
        if (columeObject?.data?.status === 200) {
          return setOptions((prev) => ({
            ...prev,
            [colume]: extractColumn(
              columeObject.data.allData,
              columeName,
              value,
            ),
          }));
        }
      };

      populateSelect("category", categoryData, "webPageName", "id"); //
      populateSelect("getPageLink", categoryData, "webPageName", "id"); //
    } catch (error) {
      swal("Error", "Error fetching Name Data", "error");
      console.log("Error fetching Name Data:", error);
    }
  };

  async function submitUpload(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
      loading: true,
    }));

    let urlpost;

    if (props.modalTitle === "POST CONTENT") {
      urlpost = `${BASE_URL}posdata`;
    } else {
      urlpost = `${BASE_URL}posdata/update`;
    }
    //console.log("###LL", urlpost);

    // if (!returnUpload.myFile) {
    //   console.log("No file Selected");
    //   return swal(
    //     "Caution",
    //     "Please select a file or image to upload",
    //     "warning",
    //   );
    // }

    if (
      currentLayout.showUploadImage &&
      !returnCrop &&
      !returnUpload?.myFile?.[0] &&
      !image
    ) {
      return swal(
        "Caution",
        "Please select a file or image to upload",
        "warning",
      );
    }

    //let fileUploadItem = returnUpload.myFile[0]; // single image
    let fileType = 1;

    if (returnCrop) {
      //fileUploadItem = returnCrop;
      fileType = 2;
    }

    let formData;

    formData = new FormData();
    if (actionType === "post") {
      formData.append("action", "post");
    }
    if (actionType === "copy") {
      formData.append("action", "copy");
    }
    let position = "center";
    if (allformData.input.chosse009 === "1") {
      position = "left";
    } else if (allformData.input.chosse009 === "2") {
      position = "center";
    } else if (allformData.input.chosse009 === "3") {
      position = "right";
    }

    if (!allformData.input.status02) {
      alert("Please select either Draft or Publish!");
      return;
    }

    formData.append("columes", allformData.select.pageLayout);
    formData.append("videod", allformData.select.videod);
    formData.append("pageName", allformData.select.category);
    formData.append("textSize", allformData.select.textDisplay);

    formData.append("display01", allformData.select.layoutDisplay);
    formData.append("width01", allformData.select.width01);

    formData.append("title", allformData.input.layout);
    formData.append("storyTitle", allformData.input.searchTitle);
    formData.append("status02", allformData.input.status02);
    formData.append("daterqw", allformData.input.creationDate);
    formData.append("readShow01", allformData.input.readShow01);
    formData.append("captions", allformData.input.captions);
    formData.append("chosse009", allformData.input.chosse009);
    formData.append("aligment009", position);
    formData.append("publisher", ADMINNAME);
    formData.append("addressLink", allformData.input.addressLink);

    formData.append("cropSize", returnRatio);
    formData.append("fileType", fileType);
    //formData.append("passport", returnCrop || returnUpload?.myFile?.[0] || "");
    if (returnCrop) {
      formData.append("passport", returnCrop);
    } else if (returnUpload?.myFile?.[0]) {
      formData.append("passport", returnUpload.myFile[0]);
    }
    formData.append("myFileUpdate", returnUpload.myFileUpdate);
    formData.append("story01", message);

    formData.append("id", props.editposts.id);
    console.log("Selected Image:", returnCrop);

    // columes, videod, page, textSize, display01, width01, title, storyTitle, status02, daterqw, readShow01, captions, chosse009, aligment009, cropSize, addressLink, displaytype, publisher, passport, story01, deletDatestramp, myFileUpdate, id

    await axios.get(`sanctum/csrf-cookie`).then((response) => {
      try {
        axios.post(urlpost, formData).then((res) => {
          if (res?.data?.status === 200) {
            swal("Success", res.data.message, "success");
            setReloadState({
              btnLoading: props.modalTitle,
              loading: false,
            });
            props.formCleanners();
            props.setCloseModal(true);
          } else {
            swal("Oops!", res.data.message, "error");
          }
        });
      } catch (error) {
        swal("Oops!", "Failed", "error");
        console.log(error.response.data);
      }
    });
  }

  async function serverPhotoImage(event) {
    event.preventDefault();

    setCloseImageModal(true);
  }
  if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }
  return (
    <>
      {closeModal ? (
        <Crop
          imageCropUrl={cropImage}
          setReturnCrop={setReturnCrop}
          returnRatio={returnRatio}
          setCloseModal={setCloseModal}
        />
      ) : null}

      {closeImageModal && (
        <>
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.7)",
              zIndex: 99999,
            }}
          >
            <div
              className="modal-dialog"
              style={{
                maxWidth: "95%",
                width: "70%",
              }}
            >
              <div className="modal-content">
                {/* HEADER */}
                <div className="modal-header bg-success text-white">
                  <h5 className="modal-title">SERVER IMAGES</h5>

                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setCloseImageModal(false)}
                  ></button>
                </div>

                {/* BODY */}
                <div
                  className="modal-body"
                  style={{
                    maxHeight: "85vh",
                    overflowY: "auto",
                  }}
                >
                  <ServerImages
                    setImage={setImage}
                    setCloseImageModal={setCloseImageModal}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* BACKDROP */}
          <div
            className="modal-backdrop fade show"
            style={{ zIndex: 99998 }}
          ></div>
        </>
      )}

      <form onSubmit={submitUpload} encType="multipart/form-data">
        <div className="row">
          <div className="col-md-9 mb-3">
            <div className="card">
              <div
                className={`card-header text-white bg-${props.btnColors} p-3`}
              >
                <i className="fa fa-newspaper"></i> {props.modalTitle}
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <SelectField
                    label="Page Layout"
                    name="pageLayout"
                    size="6"
                    placeholder="Select a Page Layout"
                    required="required"
                    value={allformData.select.pageLayout}
                    options={options.pageLayout}
                    switchOptions={1}
                    type="text"
                    onChange={updateFormData}
                    icon="fa fa-columns"
                  />
                  {currentLayout.showGeneral && (
                    <>
                      <SelectField
                        label="Category"
                        name="category"
                        size="6"
                        placeholder="Select a Category"
                        required="required"
                        value={allformData.select.category}
                        options={options.category}
                        switchOptions={1}
                        type="text"
                        onChange={updateFormData}
                        icon="fa fa-tags"
                      />

                      <InputField
                        label="Start Date"
                        name="creationDate"
                        size="6"
                        placeholder="Please Select Start Date"
                        required="required"
                        value={allformData.input.creationDate}
                        type="date"
                        onChange={updateFormData}
                        icon="fa fa-calendar-check-o"
                      />

                      <div className="col-lg-6 p-4 row">
                        <InputField
                          label="Save As Draft"
                          size="6"
                          name="status02"
                          type="radio"
                          checked={allformData.input.status02 === "draft"}
                          value="draft"
                          onChange={updateFormData}
                        />

                        <InputField
                          label="Publish"
                          size="6"
                          name="status02"
                          type="radio"
                          checked={allformData.input.status02 === "publish"}
                          value="publish"
                          onChange={updateFormData}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="card-body">
                <div className="row m-1">
                  {currentLayout.showLayout && (
                    <InputField
                      label="Layout"
                      name="layout"
                      size="6"
                      placeholder="Please Insert the Layout Title"
                      required="required"
                      value={allformData.input.layout}
                      type="text"
                      onChange={updateFormData}
                      icon="fa fa-columns"
                      options={[
                        "LATEST PRESS",
                        "OTHER NEWS",
                        "SPEECHES",
                        "PUBLIC ANNOUNCEMENT",
                        "POSTER",
                        "YOUTUBE",
                        "DOWNLOAD",
                      ]}
                    />
                  )}
                  {currentLayout.showSearchTitle && (
                    <InputField
                      label="Search Title"
                      name="searchTitle"
                      size="6"
                      placeholder="Please Insert the Search Title"
                      required="required"
                      value={allformData.input.searchTitle}
                      type="text"
                      onChange={updateFormData}
                      icon="fa fa-search-plus"
                    />
                  )}
                  {currentLayout.showTextDisplay && (
                    <SelectField
                      label="Text Display"
                      name="textDisplay"
                      size="6"
                      placeholder="Select a Text Display"
                      required="required"
                      value={allformData.select.textDisplay}
                      options={options.textDisplay}
                      switchOptions={1}
                      type="text"
                      onChange={updateFormData}
                      icon="fa fa-file-text"
                    />
                  )}
                  {currentLayout.showLayoutDisplay && (
                    <SelectField
                      label="Layout Display"
                      name="layoutDisplay"
                      size="6"
                      placeholder="Select a Layout Display"
                      required="required"
                      value={allformData.select.layoutDisplay}
                      options={options.layoutDisplay}
                      switchOptions={1}
                      type="text"
                      onChange={updateFormData}
                      icon="fa fa-file-text"
                    />
                  )}
                </div>
                {currentLayout.showMessage && (
                  <Message
                    titles="Message"
                    nameId="message"
                    placeholder="Publication/ Description"
                    size="12"
                    inputState=""
                    moreDetail={message}
                    setMessage={setMessage}
                  />
                )}
                <div className="row m-1">
                  <div className="col-lg-6 ps-4">
                    <div className="form-group mt-2">
                      <button
                        className={`btn btn-${props.btnColors} col-lg-12 mt-4`}
                        onClick={() => setActionType("post")}
                      >
                        <div className="d-flex align-items-center justify-content-center w-100">
                          <i className="fa fa-edit m-1"></i>
                          <span>{reloadState.btnLoading}</span>
                        </div>
                      </button>
                    </div>
                  </div>

                  <div className="col-lg-6 ps-4">
                    <div className="form-group mt-2">
                      <button
                        className={`btn btn-secondary col-lg-12 mt-4`}
                        onClick={() => setActionType("copy")}
                      >
                        <div className="d-flex align-items-center justify-content-center w-100">
                          <i className="fa fa-clone m-1"></i>
                          <span>COPY POST</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-3">
            <SelectField
              label="Get Page Link"
              name="getPageLink"
              size="12"
              placeholder="Select a Category"
              value={allformData.select.getPageLink}
              options={options.getPageLink}
              switchOptions={1}
              type="text"
              onChange={updateFormData}
              icon="fa fa-link"
            />
            <InputField
              label="Page Link"
              name="pageLink"
              size="12"
              value={allformData.input.pageLink}
              type="text"
              disabled
              onChange={updateFormData}
              icon="fa fa-link"
            />
            {/*pageLink*/}
            {/* send data to be displayed, collect processed result for the parent componet*/}
            {currentLayout.showUploadImage && (
              <>
                <FileUpload
                  editposts={image}
                  setReturnUpload={setReturnUpload}
                  maxFiles={1} //maxFiles={5} or multiple
                  titileHead={"IMAGE/ DOC. UPLOAD"}
                />

                <div className="col-lg-12 ps-4">
                  <div className="form-group mt-2">
                    <button
                      className={`btn btn-secondary col-lg-12 mt-4`}
                      onClick={serverPhotoImage}
                    >
                      <div className="d-flex align-items-center justify-content-center w-100">
                        <i className="fa fa-image m-1 me-2"></i>
                        <span>Server Image</span>
                      </div>
                    </button>
                  </div>
                </div>
              </>
            )}
            {currentLayout.showCropImage && (
              <CropRatio
                setCloseModal={setCloseModal}
                setCropImage={setCropImage}
                //returnUploader={returnUpload.myFileUrl}
                returnUploader={returnUpload.myFileUrl?.[0]}
                setReturnRatio={setReturnRatio}
                defaultRatio={returnRatio}
              />
            )}

            {currentLayout.showImageSettings && (
              <>
                <InputField
                  label="Captions"
                  name="captions"
                  size="12"
                  placeholder="Please Insert an image Caption"
                  required="required"
                  value={allformData.input.captions}
                  type="text"
                  onChange={updateFormData}
                  icon="fa fa-comment"
                />
                <SelectField
                  label="Image Width"
                  name="width01"
                  size="12"
                  placeholder="Select a Image Width"
                  required="required"
                  value={allformData.select.width01}
                  options={options.width01}
                  switchOptions={1}
                  type="text"
                  onChange={updateFormData}
                  icon="fa fa-expand"
                />
                <div className="col-lg-12 ps-3 row">
                  <label for="Image Position" className="col-sm-12">
                    <i
                      className={"fa fa-align-center"}
                      style={{ fontSize: "20px" }}
                    />
                    <i /> Image Position:
                  </label>
                  <InputField
                    label="Left"
                    size="4"
                    name="chosse009"
                    type="checkbox"
                    checked={allformData.input.chosse009 === "1"}
                    value="1"
                    onChange={updateFormData}
                  />

                  <InputField
                    label="Center"
                    size="4"
                    name="chosse009"
                    type="checkbox"
                    checked={allformData.input.chosse009 === "2"}
                    value="2"
                    onChange={updateFormData}
                  />

                  <InputField
                    label="Right"
                    size="4"
                    name="chosse009"
                    type="checkbox"
                    checked={allformData.input.chosse009 === "3"}
                    value="3"
                    onChange={updateFormData}
                  />
                </div>
              </>
            )}

            {currentLayout.showLinks && (
              <>
                <div className="col-lg-12 pb-4"></div>
                <hr />
                <SelectField
                  label="LINKS"
                  name="videod"
                  size="12"
                  placeholder="Select a Image Width"
                  required="required"
                  value={allformData.select.videod}
                  options={options.videod}
                  switchOptions={1}
                  type="text"
                  onChange={updateFormData}
                  icon="fa fa-link"
                />
                <InputField
                  label="LINK ADD."
                  name="addressLink"
                  size="12"
                  placeholder="Youtube/Google (ynEdL95ES2Y)"
                  required="required"
                  value={allformData.input.addressLink}
                  type="text"
                  onChange={updateFormData}
                  icon="fa fa-link"
                />
                * External link: https://any_external_link
              </>
            )}
            {currentLayout.showPoster && (
              <>
                <div className="col-lg-12 pb-4"></div>
                <hr />

                <InputField
                  label="POSTER"
                  name="readShow01"
                  size="12"
                  placeholder="Poster Word e.g (Click To View)"
                  required="required"
                  value={allformData.input.readShow01}
                  type="text"
                  onChange={updateFormData}
                  icon="fa fa-picture-o"
                />
              </>
            )}
          </div>
        </div>
      </form>
    </>
  );
};
export default ModalPos;
